<template>
  <v-dialog v-model="dialog" max-width="400px" max-height="200px" eager>
    <vue-cropper :key="23871289372189" ref="cropper2" hidden eager style="overflow: hidden" :guides="false"
      :view-mode="2" :aspect-ratio="0.75" :min-container-width="200" :min-container-height="200" drag-mode="move"
      :responsive="false" :auto-crop-area="1" :background="true" :rotatable="true" alt="Source Image"
      :check-cross-origin="false" :class="circle ? 'rounded-circle' : 'rounded-sm'" @ready="cropSave2" />
    <template v-slot:activator="{ on }">
      <v-hover :style="`max-height: ${maxHei}; max-width: 500px; height: ${height};`">
        <template v-slot:default="{ hover }">
          <v-card :class="circle ? 'rounded-circle pa-0 ma-0' : 'pa-0 ma-0'" fluid elevation="0">
            <FileDrop ref="file-drop" :disabled="disableOnFill && loaded_image" @files-selected="handleFiles">
              <v-img :class="circle ? 'rounded-circle' : 'rounded-sm'" :max-height="maxHei" :max-width="maxWid"
                :height="height" :contain="circle ? false : true" :src="showImage" :style="!loaded_image ? 'background-color: RGB(198, 198, 198);' : ''
                  " />
              <v-fade-transition>
                <div v-if="hover" color="#fff" style="margin-top: 10px" :z-index="1">
                  <div v-if="!loaded_image" @click="selectFiles">
                    <v-btn class="pa-8" icon color="primary lighten-1">
                      <v-icon large> mdi-camera </v-icon>
                    </v-btn>
                    <span class="primary--text text--lighten-1 text-center">
                      Clique aqui e escolha uma imagem
                    </span>
                    <span class="primary--text text--lighten-1 text-center my-2">
                      ou
                    </span>
                    <span class="primary--text text--lighten-1 text-center mt-1">
                      arraste um arquivo.
                    </span>
                  </div>
                  <div v-else :class="circle ? 'rounded-circle' : ''">
                    <v-btn v-if="editable" class="pa-8" icon color="primary lighten-1" v-on="on" @click="att">
                      <v-icon large> mdi-pencil </v-icon>
                    </v-btn>
                    <v-btn class="pa-8" icon color="primary lighten-1" @click="reset">
                      <v-icon large> mdi-delete </v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-fade-transition>
            </FileDrop>
          </v-card>
        </template>
      </v-hover>
    </template>
    <v-card justify="center" align="center">
      <v-container>
        <v-card-actions class="justify-center">
          <v-btn class="text-none text-white" color="primary" rounded @click="setAspectRatio(1)">
            Quadrado
          </v-btn>
          <v-btn class="text-none text-white" color="primary" rounded @click="setAspectRatio(2 / 1)">
            Paisagem
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-card class="pa-0 mb-2" fluid elevation="0">
            <vue-cropper :key="id" ref="cropper" :guides="false" :view-mode="2" :min-container-width="300"
              :min-container-height="400" drag-mode="move" :responsive="true" :auto-crop-area="1"
              :aspectRatio="aspectRatio" :initialAspectRatio="aspectRatio" alt="Source Image"
              :check-cross-origin="false" @ready="crop" />
          </v-card>
          <small>Recorte e ajuste o tamanho da imagem</small>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn class="text-none text-white" color="error" rounded @click="dialog = false">
            <v-icon dark left> mdi-minus-circle </v-icon>
            Cancelar
          </v-btn>
          <v-btn class="text-none text-white" color="success" rounded @click="
            () => {
              cropSave();
              dialog = false;
            }
          ">
            <v-icon dark left> mdi-checkbox-marked-circle </v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { v4 } from "uuid";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  components: {
    VueCropper,
  },
  model: {
    prop: "image",
    event: "setImage",
  },
  props: {
    image: {
      type: [String, Object],
      default: null,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    noData: {
      type: String,
      default: null,
    },
    disableOnFill: {
      type: Boolean,
      default: true,
    },
    dialogTitle: {
      type: String,
      default: "Imagem",
    },
    maxHei: {
      type: String,
      default: "165px",
    },
    maxWid: {
      type: String,
      default: "165px",
    },
    height: {
      type: String,
      default: "220px",
    },
    width: {
      type: String,
      default: "220px",
    },
    circle: {
      type: Boolean,
      default: false,
    },
    // Novas props para controle de compressão
    maxSizeKB: {
      type: Number,
      default: 100 // 100KB máximo
    },
    targetQuality: {
      type: Number,
      default: 0.7, // 70% qualidade inicial
      validator: value => value > 0 && value <= 1
    },
    minQuality: {
      type: Number,
      default: 0.3, // Nunca menos que 30%
      validator: value => value > 0 && value <= 1
    },
    maxWidth: {
      type: Number,
      default: 600
    },
    maxHeight: {
      type: Number,
      default: 600
    }
  },
  data() {
    return {
      id: v4(),
      dialog: false,
      loading: true,
      overlay: false,
      cropped_image: null,
      aspectRatio: 2 / 1,
      compressionInfo: null
    };
  },
  computed: {
    showImage() {
      return this.image || this.noData;
    },
    loaded_image() {
      return !!this.image;
    },
  },
  mounted() {
    if (this.image) {
      this.cropped_image = this.image;
      this.$refs.cropper2.replace(this.image);
      this.cropSave2();
    } else {
      this.cropped_image = null;
      this.$refs.cropper.reset();
    }
  },
  methods: {
    att() {
      this.$refs.cropper.replace(this.image);
    },
    handleFiles($event) {
      const reader = new FileReader($event[0]);
      let image = null;
      reader.onload = (e) => {
        image = e.target.result;
        this.dialog = true;
        this.$refs.cropper.replace(image);
        this.$emit("upload", image);
      };
      reader.readAsDataURL($event[0]);
    },
    selectFiles() {
      this.$refs["file-drop"].activate();
    },
    crop() {
      // Método vazio para o evento ready
    },
    
    async cropSave() {
      try {
        // Obter canvas recortado com dimensões reduzidas
        const cpcanvas = this.$refs.cropper.getCroppedCanvas({
          maxWidth: this.maxWidth,
          maxHeight: this.maxHeight,
          fillColor: "#fff",
          imageSmoothingEnabled: true,
          imageSmoothingQuality: 'low'
        });

        if (!cpcanvas) {
          console.error("Canvas não disponível");
          return;
        }

        // Comprimir para JPEG com tamanho controlado
        const compressed = await this.compressToJPEG(cpcanvas, {
          maxSizeKB: this.maxSizeKB,
          targetQuality: this.targetQuality,
          minQuality: this.minQuality
        });

        // Atualizar imagem
        this.cropped_image = compressed.dataURL;
        
        // Mostrar informação de compressão
        this.compressionInfo = `Imagem otimizada: ${compressed.sizeKB}KB (JPEG ${Math.round(compressed.quality * 100)}%)`;
        
        // Emitir eventos
        this.$emit("setImage", this.cropped_image);
        this.$emit("upload", this.cropped_image);
        
        // Limpar mensagem após 3 segundos
        setTimeout(() => {
          this.compressionInfo = null;
        }, 3000);

      } catch (error) {
        console.error("Erro ao processar imagem:", error);
        this.$emit("error", error);
      }
    },

    compressToJPEG(canvas, settings) {
      return new Promise((resolve, reject) => {
        try {
          const { maxSizeKB, targetQuality, minQuality } = settings;
          
          let currentCanvas = canvas;
          let currentQuality = targetQuality;
          let compressedDataURL;
          let sizeKB;

          // Primeira tentativa com qualidade inicial
          compressedDataURL = currentCanvas.toDataURL("image/jpeg", currentQuality);
          sizeKB = compressedDataURL.length / 1024;

          // Se já estiver abaixo do limite, retornar
          if (sizeKB <= maxSizeKB) {
            return resolve({
              dataURL: compressedDataURL,
              sizeKB: Math.round(sizeKB),
              quality: currentQuality,
              width: currentCanvas.width,
              height: currentCanvas.height
            });
          }

          // Tentativa 1: Reduzir qualidade progressivamente
          while (sizeKB > maxSizeKB && currentQuality > minQuality) {
            currentQuality -= 0.05;
            compressedDataURL = currentCanvas.toDataURL("image/jpeg", currentQuality);
            sizeKB = compressedDataURL.length / 1024;
          }

          // Se ainda estiver grande após reduzir qualidade
          if (sizeKB > maxSizeKB) {
            // Tentativa 2: Reduzir dimensões e tentar novamente
            const originalWidth = currentCanvas.width;
            const originalHeight = currentCanvas.height;
            
            // Calcular fator de escala baseado no tamanho desejado
            const targetSizeRatio = Math.sqrt(maxSizeKB / sizeKB);
            const newWidth = Math.max(100, Math.floor(originalWidth * targetSizeRatio * 0.8));
            const newHeight = Math.max(100, Math.floor(originalHeight * targetSizeRatio * 0.8));
            
            // Criar novo canvas com dimensões reduzidas
            const tempCanvas = document.createElement('canvas');
            const ctx = tempCanvas.getContext('2d');
            tempCanvas.width = newWidth;
            tempCanvas.height = newHeight;
            
            // Redesenhar com qualidade baixa de redimensionamento
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'low';
            ctx.drawImage(currentCanvas, 0, 0, newWidth, newHeight);
            
            // Tentar com qualidade razoável
            currentQuality = 0.6;
            compressedDataURL = tempCanvas.toDataURL("image/jpeg", currentQuality);
            sizeKB = compressedDataURL.length / 1024;
            
            // Se ainda estiver grande, reduzir qualidade mais um pouco
            while (sizeKB > maxSizeKB && currentQuality > 0.2) {
              currentQuality -= 0.05;
              compressedDataURL = tempCanvas.toDataURL("image/jpeg", currentQuality);
              sizeKB = compressedDataURL.length / 1024;
            }
            
            currentCanvas = tempCanvas;
          }

          resolve({
            dataURL: compressedDataURL,
            sizeKB: Math.round(sizeKB),
            quality: currentQuality,
            width: currentCanvas.width,
            height: currentCanvas.height
          });

        } catch (error) {
          reject(error);
        }
      });
    },

    // Versão simplificada para cropSave2 (thumbnail)
    cropSave2() {
      try {
        const cpcanvas = this.$refs.cropper2.getCroppedCanvas({
          maxWidth: 400, // Reduzido para thumbnail
          maxHeight: 400,
          fillColor: "#fff",
          imageSmoothingEnabled: true,
          imageSmoothingQuality: 'low'
        });
        
        if (cpcanvas) {
          // Usar qualidade fixa baixa para thumbnail
          this.cropped_image = cpcanvas.toDataURL("image/jpeg", 0.5); // 50% qualidade
          this.$emit("setImage", this.cropped_image);
        }
      } catch (error) {
        console.error("Erro no cropSave2:", error);
      }
    },

    reset() {
      this.$refs.cropper.reset();
      this.cropped_image = null;
      this.compressionInfo = null;
      this.$emit("setImage", null);
      this.$emit("delete", null);
    },

    setAspectRatio(ratio) {
      this.aspectRatio = ratio;
      this.$refs.cropper.setAspectRatio(ratio);
    },

    // Método para debug - mostra informações da imagem
    getImageInfo(dataURL) {
      if (!dataURL) return { size: 0, dimensions: 'N/A' };
      
      const sizeKB = Math.round(dataURL.length / 1024);
      
      // Tentar obter dimensões da imagem
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          resolve({
            size: sizeKB,
            dimensions: `${img.width}x${img.height}`,
            format: dataURL.substring(5, dataURL.indexOf(';'))
          });
        };
        img.onerror = () => {
          resolve({
            size: sizeKB,
            dimensions: 'N/A',
            format: dataURL.substring(5, dataURL.indexOf(';'))
          });
        };
        img.src = dataURL;
      });
    }
  },
};
</script>

<style scoped>
/* Adicionar transição suave para a mensagem de compressão */
.v-alert {
  transition: opacity 0.3s ease;
}
</style>